/**
 * 滚动触发动画的 composable
 * 当元素进入视口时添加动画类
 */
import { ref, onMounted, onUnmounted } from 'vue'

export function useScrollReveal() {
  const observer = ref(null)

  onMounted(() => {
    observer.value = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed')
            // 可选的：动画只触发一次后就取消观察
            observer.value.unobserve(entry.target)
          }
        })
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      }
    )

    // 观察所有带有 .reveal-on-scroll 类的元素
    document.querySelectorAll('.reveal-on-scroll').forEach((el) => {
      observer.value.observe(el)
    })

    // 也观察新动态添加的元素
    const mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            if (node.classList && node.classList.contains('reveal-on-scroll')) {
              observer.value.observe(node)
            }
            node.querySelectorAll?.('.reveal-on-scroll').forEach((el) => {
              observer.value.observe(el)
            })
          }
        })
      })
    })

    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    })
  })

  onUnmounted(() => {
    if (observer.value) {
      observer.value.disconnect()
    }
  })

  return { observer }
}